var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"truncate-text"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm._f("truncate")(_vm.text,_vm.clamp)))]}),(_vm.text.length > _vm.clamp)?_c('div',{staticClass:"menu_drop"},[_c('div',{staticClass:"dropdown"},[_vm._t("description",function(){return [_vm._v(_vm._s(_vm.text))]})],2)]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }